import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";
import { cardMixin, innerMiddleMixin } from "../mixin";

export const ContainerAniversaryDoubleContainer = styled.div`
  margin: 0 auto;
  max-width: 1024px;
  margin-top: 100px;
  ${breakpoints.phone} {
    margin-top: 60px;
    }
`;

export const ParentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  margin: 10px 0;
  ${breakpoints.phone} {
    grid-template-columns: repeat(1, 1fr);
    padding: 0 12px;
  }
  > div {
    position: relative;
  }
  .card {
    width: 100%;
    height: 100%;
    border-bottom: 1px solid ${Color.greySeparator};
    margin: 10px 0;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        border-bottom: 1px solid ${ColorDark.greySeparator};
      }
    }
  }
  .div1,
  .div3,
  .div5,
  .div7,
  .div9,
  .div11 {
    .NewsAniversary,
    .NewsAniversarySmall {
      padding-right: 20px;
      ${breakpoints.phone} {
        padding-right: 0px;
      }
    }
  }
  .div2,
  .div4,
  .div6,
  .div8,
  .div10,
  .div12 {
    .NewsAniversary,
    .NewsAniversarySmall {
      padding-left: 20px;
      ${breakpoints.phone} {
        padding-left: 0px;
      }
    }
  }
  .div1 {
    & > div {
      border-right: 1px solid ${Color.greySeparator};
      ${breakpoints.phone} {
        border-right: none;
      }
    }
  }

  /*Estilos para Skeleton*/
  .div1.visual-skeleton {
    height: 649px;
    ${breakpoints.phone} {
      height: auto;
    }
  }
  .div3.normal-skeleton,
  .div4.normal-skeleton,
  .div5.normal-skeleton,
  .div6.normal-skeleton {
    height: 140px;
    overflow: hidden;
    padding-top: 0 !important;
    flex-direction: row-reverse !important;
    ${breakpoints.phone} {
      justify-content: space-between;
      height: 150px;
    }
    .mt {
      margin-top: 15px !important;
      width: 42%;
      margin-right: 16px;
      ${breakpoints.phone} {
        width: 60%;
      }
    }
    .picture {
      width: 135px;
      height: 135px;
      ${breakpoints.phone} {
        width: 125px;
        height: 125px;
        min-height: unset;
        aspect-ratio: unset;
      }
    }
  }
`;
